const trafficSignalMutations = {
  setTrafficSignalOptions(state, payload) {
    state.trafficSignalOptions = payload;
  },
  setTrafficSignalTemplates(state, payload) {
    state.trafficSignalTemplates = payload;
  },
};
export default trafficSignalMutations;
